export default class MenuItem {

    constructor(name, route, children = [], exactMatch = false) {
        this.name = name;
        this.route = route;
        this.children = children;
        this.exactMatch = exactMatch;
    }

}
